module.exports = __webpack_public_path__ + "static/media/SHSN.3e831286.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SHSN.ttf
// module id = 1030
// module chunks = 3